import React from 'react'
import { observer } from 'mobx-react'
import { stateStore, authStore } from '../../store'

const LayoutMapLegendLink = observer(() => (
  <li>
    <button
      onClick={() => {
        stateStore.currentModal = 'MapLegend' 
      }}
    >
      MAP LEGEND
    </button>
  </li>
))

export {LayoutMapLegendLink}